import { ApiPostGameQuestionMetaDataIsThisCompOn } from "apiRoutes/apiQuestionRoutes";
import { GameAnswerIsThisCompressorOn } from "shared/games/types/GameAnswers";
import { GameQuestionIsThisCompressorOn } from "shared/games/types/GameQuestions";
import createGame from "../../createGame";
import IsThisCompOnFailedScreen from "./pages/IsThisCompOnFailedScreen";
import IsThisCompOnGame from "./pages/IsThisCompOnGame";
import generateOnSubmitHandler from "shared/games/generateOnSubmitHandler";

export default createGame<
  GameQuestionIsThisCompressorOn,
  GameAnswerIsThisCompressorOn
>({
  Game: IsThisCompOnGame,
  FailureScreen: IsThisCompOnFailedScreen,
  onSubmit: generateOnSubmitHandler<
    GameQuestionIsThisCompressorOn,
    GameAnswerIsThisCompressorOn,
    ApiPostGameQuestionMetaDataIsThisCompOn
  >(({ answer, game, pointsEarned, question }) => ({
    correct: answer.correct,
    difficulty: question.difficulty,
    points: pointsEarned,
    game: question.type,
    instrument: question.instrument.instrument,
    technique: game.technique,
    metadata: {
      a: question.options.a,
      b: question.options.b,
      question_compression: question.answer,
      answer_compression: answer.submission,
    },
  })),
});
